"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
function hasChildren(item) {
  return (0, _lodash.has)(item, 'children') && !(0, _lodash.isEmpty)(item.children);
}
var _default = exports["default"] = hasChildren;